import { composeIO } from 'react-compose-io'
import { modalConfiguracoesGeraisIO } from './ModalConfiguracoesGerais.IO'
import { ModalConfiguracoesGeraisView } from './ModalConfiguracoesGerais.View'

export const ModalConfiguracoesGerais = composeIO(ModalConfiguracoesGeraisView, modalConfiguracoesGeraisIO)
